import { Avatar } from '@material-ui/core';
import React from 'react';
import '../styles/Post.css';
import InputOption from './InputOption';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ChatIcon from '@material-ui/icons/Chat';
import ShareIcon from '@material-ui/icons/Share';
import SendIcon from '@material-ui/icons/Send';

function Post({name,description,message,photoUrl}) {
    return (
        <div className="post">
            <div className="post_header">
                <Avatar>{photoUrl}</Avatar>
                <div className="post_by_info">
                    <h3>{name}</h3>
                    <span>{description}</span>
                </div>
            </div>

            <div className="post_body">
                <span>{message}</span>
            </div>
            <div className="post_buttons">
                <InputOption Icon={ThumbUpIcon} color="gray" title="Like"/>
                <InputOption Icon={ChatIcon} color="gray" title="Comment"/>
                <InputOption Icon={ShareIcon} color="gray" title="Share"/>
                <InputOption Icon={SendIcon} color="gray" title="Send"/>
            </div>
        </div>
    );
}

export default Post;